import Background from '@do/walrus/Background';
import { smallMax } from '@do/walrus/MediaQueries';
import vars from '@do/walrus/scss/core/_variables.scss';
import * as React from 'react';
import styled, { createGlobalStyle, css } from 'styled-components';
import Coral1 from '../assets/backgrounds/coral-1.png';
import Coral2 from '../assets/backgrounds/coral-2.png';
import Coral3 from '../assets/backgrounds/coral-3.png';

interface BackgroundPositionedImageProps {
  src: string;
  height: string;
  width: string;
  left?: string;
  right?: string;
}

/**
 * This is to prevent side scrolling because the corals are placed partially off the screen
 */
const BodyOverFlowStyle = createGlobalStyle`
  body {
    overflow-x: hidden;
  }
`;

const BackgroundPositionedImage = styled.div<BackgroundPositionedImageProps>`
  position: fixed;
  bottom: 0;
  background-size: cover;
  z-index: ${vars.z_index_base};

  ${smallMax} {
    display: none;
  }

  ${({ src, height, width }) =>
    css`
      background-image: url(${src});
      height: ${height};
      width: ${width};
    `}

  right: ${({ right }) =>
    css`
      ${right}
    `};
  left: ${({ left }) =>
    css`
      ${left}
    `};
`;

const CoralBackground: React.FC = () => (
  <>
    <BodyOverFlowStyle />
    <Background color="#E5E7EE" />
    <BackgroundPositionedImage
      src={Coral1}
      height="527px"
      width="310px"
      left="-15px"
    />
    <BackgroundPositionedImage
      src={Coral3}
      height="403px"
      width="205px"
      right="-25px"
    />
    <BackgroundPositionedImage
      src={Coral2}
      height="676px"
      width="308px"
      right="25px"
    />
  </>
);

export default CoralBackground;
